import React, { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { SpeakerNotesOutlined, QuestionAnswerOutlined } from '@mui/icons-material';
import { LessonSection } from 'controllers/types';
import { SegmentDetail } from './SegmentDetail';

type SectionListEditorProps = {
  lessonSections: LessonSection[];
};

export function SectionListEditor({ lessonSections }: SectionListEditorProps) {
  const [selectedIndices, setSelectedIndices] = useState({ sectionIdx: 0, segmentIdx: 0 });
  const selectedSection = lessonSections[selectedIndices.sectionIdx];
  const selectedSegment = selectedSection?.segments[selectedIndices.segmentIdx];

  return (
    // NOTE: THIS IS A PLACEHOLDER IMPLEMENTATION BEHIND FEATURE FLAG
    <Stack direction='row' m={2} spacing={3} sx={{ overflowY: 'auto' }}>
      <Stack>
        {lessonSections.map((section, sectionIdx) => (
          <div key={section.id}>
            <Typography>{section.topic}</Typography>
            <Stack>
              {section.segments.map((segment, segmentIdx) => (
                <Box key={segment.id}>
                  <Button
                    startIcon={segment.segment_type === 'step' ? <SpeakerNotesOutlined /> : <QuestionAnswerOutlined />}
                    onClick={() => setSelectedIndices({ sectionIdx, segmentIdx })}
                    sx={{ textAlign: 'left' }}
                    variant='text'
                    color={selectedSegment?.id === segment.id ? 'primary' : 'inherit'}
                  >
                    {segment.segment_type}
                  </Button>
                </Box>
              ))}
            </Stack>
          </div>
        ))}
      </Stack>
      <SegmentDetail segmentId={selectedSegment?.id} />
    </Stack>
  );
}
